import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Stack } from '@mui/material';

const Loader = () =>  {
  
  const [ isAlertVisible, setIsAlertVisible ] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      console.log('Initial timeout!')
      setIsAlertVisible(false)
    
    }, 4000);
  }, []);

  return(
    <>
      {isAlertVisible && 
      

        <Stack width="100%" minHeight="95vh" direction='row' justifyContent='center' alignItems='center'>
            <Stack  height='80vh' >
              <CircularProgress />
            </Stack>
          </Stack>
      }
    </>
  
)
};

export default Loader;